import Dispatch from '../Dispatcher'

Dispatch.nextState('menu', { open: false })